import type { TimeAction } from "../types";
export default function time(
  state: {
    time: number;
    now: number;
  } = {
    time: 0,
    now: 0,
  },
  action: TimeAction
): {
  time: number;
  now: number;
} {
  switch (action.type) {
    case "SET_NOW":
      if (state.time === state.now) {
        return {
          time: action.now,
          now: action.now,
        };
      } else {
        return { ...state, now: action.now };
      }
  }

  return state;
}
